import React from "react";
import { Select, MenuItem, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { Stack, useMediaQuery } from "@mui/system";
import { useTranslation } from "react-i18next";

// Importa le immagini
import suite1 from "../../assets/roomMenuAssets/crown.png";
import suite2 from "../../assets/roomMenuAssets/crownb.png";
import room1 from "../../assets/roomMenuAssets/cheers.png";
import room2 from "../../assets/roomMenuAssets/sailing.png";
import room3 from "../../assets/roomMenuAssets/floral.png";

const RoomMenu = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const roomsData = [
    {
      id: 1,
      name: t("roomsInfoSingles.0.name"),
      label: t("roomsInfoSingles.0.title"),
      icon: (
        <img src={suite1} alt="Suite 1" style={{ width: 20, height: 20 }} />
      ), // Icona per la suite 1
    },
    {
      id: 2,
      name: t("roomsInfoSingles.1.name"),
      label: t("roomsInfoSingles.1.title"),
      icon: <img src={suite2} alt="Room 1" style={{ width: 20, height: 20 }} />, // Icona per la camera 1
    },
    {
      id: 3,
      name: t("roomsInfoSingles.2.name"),
      label: t("roomsInfoSingles.2.title"),
      icon: <img src={room2} alt="Room 2" style={{ width: 20, height: 20 }} />, // Icona per la camera 2
    },
    {
      id: 4,
      name: t("roomsInfoSingles.3.name"),
      label: t("roomsInfoSingles.3.title"),
      icon: (
        <img src={room3} alt="Suite 2" style={{ width: 22.5, height: 22.5 }} />
      ), // Icona per la suite 2
    },
    {
      id: 5,
      name: t("roomsInfoSingles.4.name"),
      label: t("roomsInfoSingles.4.title"),
      icon: <img src={room1} alt="Room 3" style={{ width: 20, height: 20 }} />, // Icona per la camera 3
    },
  ];
  const [selectedRoom, setSelectedRoom] = React.useState(roomsData[0].id);
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();
  const handleRoomChange = (newRoomId) => {
    setIsOpen(false);
    setSelectedRoom(newRoomId);
    setTimeout(() => {
      navigate(`/rooms/${newRoomId}`);
    }, 100);
  };
  const handleToggle = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };
  const getTruncatedLabel = (label, roomId) => {
    if (roomId === 4) return label.split(" ").slice(0, 1).join(" ");
    return label.split(" ").slice(0, 2).join(" ");
  };

  return (
    <Stack
      width="100vw"
      alignItems="center"
      sx={{ backgroundColor: "white", display: isMobile ? "flex" : "none" }}
    >
      <Select
        value={selectedRoom}
        onClick={handleToggle}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          width: "100vw",
          zIndex: 1000,
          border: "none",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          ".MuiSelect-select": {
            borderRadius: 0,
            padding: "10px 20px",
          },
          paddingRight: 0,
        }}
        IconComponent={() => null}
        renderValue={() => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant={"body2"}
              sx={{ fontWeight: 500, fontSize: "16px" }}
            >
              ROOMS
            </Typography>
            <ArrowDropDownIcon sx={{ marginLeft: "2px" }} />
          </div>
        )}
      >
        {roomsData.map((room) => (
          <MenuItem
            key={room.id}
            value={room.id}
            onClick={() => handleRoomChange(room.id)}
            sx={{
              width: "100vw",
              paddingLeft: 1.5,
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {room.icon}
              <Typography sx={{ fontWeight: 600 }}>{room.label}</Typography>
              <Typography
                sx={{ color: "gray", fontStyle: "italic", fontSize: "14px" }}
              >
                {getTruncatedLabel(room.name, room.id)}
              </Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

export default RoomMenu;
